var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1075 2.16394H15.7039C16.4191 2.16394 17 2.7429 17 3.45578V10.1416C17 10.8545 16.4191 11.4334 15.7039 11.4334H14.3519V13.6607C14.3519 14.0295 13.9034 14.2149 13.6408 13.9532L11.1106 11.4314H5.1075C4.39225 11.4314 3.81137 10.8524 3.81137 10.1395V3.45578C3.81137 2.7429 4.39225 2.16394 5.1075 2.16394Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29612 3.62888C1.58088 3.62888 1 4.20783 1 4.92071V11.6065C1 12.3194 1.58088 12.8984 2.29612 12.8984H3.64806V15.1256C3.64806 15.4944 4.09664 15.6798 4.35917 15.4182L6.88941 12.8963H10.4057",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5219C9 4.66717 9.69415 3.97659 10.5421 4.00061C11.325 4.02263 11.9778 4.68519 11.9995 5.47986C12.0152 6.08237 11.6879 6.60882 11.1988 6.87104C10.7788 7.09523 10.4987 7.51759 10.4987 8",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4057 9.5853V9.49997",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.ea3f08a919b0bdc4eadf61b0bfb00d65.svg";
export { ForwardRef as ReactComponent };